import type { BlockExport } from "@/react/components/shared/BuilderUI/BuilderUI.types";
import { FormStackBlock as Block } from "./FormStackBlock";
import { defaultData } from "./FormStackBlockDefaultData";
import { meta } from "./FormStackBlockMetaData";

export const FormStackBlock: BlockExport = {
  type: "component",
  Block,
  defaultData,
  imagePreview: {
    type: "icon",
    name: "24-builder-element-stack",
    size: 24,
  },
  meta,
};
